import { render, staticRenderFns } from "./DashboardBoxOrdini.vue?vue&type=template&id=107ad133&scoped=true&"
import script from "./DashboardBoxOrdini.vue?vue&type=script&lang=js&"
export * from "./DashboardBoxOrdini.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBoxOrdini.vue?vue&type=style&index=0&id=107ad133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ad133",
  null
  
)

export default component.exports